import {
  DEFAULT_ACCESS,
  MEMBER_AND_HIGHER,
  SUPERVISOR_AND_HIGHER,
} from "@/router/roles.js";
import Login from "@/features/auth/Login.jsx";
import ResetPassword from "@/features/auth/ResetPassword.jsx";
import ResetPasswordConfirm from "@/features/auth/ResetPasswordConfirm.jsx";
import EmailVerificationResend from "@/features/auth/EmailVerificationResend.jsx";
import EmailVerification from "@/features/auth/EmailVerification.jsx";
import Home from "@/features/home/index.jsx";
import Register from "@/features/auth/Register.jsx";
import PrivacyPolicy from "@/features/PrivacyPolicy.jsx";
import Community from "@/features/community/Community.jsx";
import DiscussionForm from "@/features/community/DiscussionForm.jsx";
import SingleDiscussion from "@/features/community/SingleDiscussion.jsx";
import CommunityTopicSearch from "@/features/community/CommunityTopicSearch.jsx";
import CommunitySearch from "@/features/community/CommunitySearch.jsx";
import SurveyViewCreate from "@/pages/survey-views/SurveyViewCreate.tsx";
import SurveyViewUpdate from "@/pages/survey-views/SurveyViewUpdate.tsx";
import SurveyView from "@/pages/survey-views/SurveyView.tsx";
import PublicFile from "@/pages/survey-views/PublicFile.tsx";
import Organization from "@/pages/organizations/Organization.tsx";
import Directory from "@/pages/directory/Directory.tsx";
import SurveyViewList from "@/pages/survey-views/SurveyViewList.js";
import DataFiles from "@/pages/files/DataFiles.js";
import User from "@/pages/users/User.js";
import UserSettings from "@/pages/settings/UserSettings.js";
import DataBlockRequests from "@/features/evidence-requests/list";
import Surveys from "@/pages/surveys/Surveys.js";
import SurveyOverview from "@/features/survey/overview/index.jsx";
import SurveyDetails from "@/pages/surveys/SurveyDetails.js";
import SurveySection from "@/pages/surveys/SurveySection.tsx";
import EvidenceDocumentationPage from "@/pages/evidence/EvidenceDocumentation.js";
import Evidence from "@/pages/evidence/Evidence.js";
import EvidenceDetails from "@/pages/evidence/EvidenceDetails.js";
import EvidenceEdit from "@/pages/evidence/EvidenceEdit.js";
import SubmissionSuccessPage from "@/pages/surveys/SubmissionSuccessPage.js";
import GuidancePageRoute from "@/pages/surveys/GuidancePageRoute.tsx";

export const PublicRoutes = [
  {
    path: "/login",
    view: Login,
  },
  {
    path: "/register",
    view: Register,
  },
  {
    path: "/reset-password/confirm",
    view: ResetPasswordConfirm,
  },
  {
    path: "/reset-password",
    view: ResetPassword,
  },
  {
    path: "/email-verification",
    view: EmailVerification,
  },
  {
    path: "/email-verification/resend",
    view: EmailVerificationResend,
  },
  {
    path: "/public/reports/files/:uuid",
    view: PublicFile,
  },
  {
    path: "/public/reports/views/:surveyViewUuid",
    view: SurveyView,
  },
];

export const PrivateRoutes = [
  {
    path: "/",
    view: Home,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/privacy-policy",
    view: PrivacyPolicy,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/users/:userId",
    view: User,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/settings",
    view: UserSettings,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/directory",
    view: Directory,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/signatories/:organizationId",
    view: Organization,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/evidence",
    view: Evidence,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/evidence/:dataBlockId",
    view: EvidenceDetails,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/evidence/:dataBlockId/edit",
    view: EvidenceEdit,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/evidence/documentation",
    view: EvidenceDocumentationPage,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/evidence/invites",
    view: DataBlockRequests,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/files",
    view: DataFiles,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/reports",
    view: Surveys,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId",
    view: SurveyDetails,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId/sample",
    view: SurveyDetails,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId/section/:sectionId",
    view: SurveySection,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId/section/:sectionId/sample",
    view: SurveySection,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId/submission-success",
    view: SubmissionSuccessPage,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/:surveyId/overview",
    view: SurveyOverview,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/reports/:surveyId/guidance",
    view: GuidancePageRoute,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/reports/views",
    view: SurveyViewList,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/reports/views/:surveyViewUuid",
    view: SurveyView,
    ...DEFAULT_ACCESS,
  },
  {
    path: "/reports/views/form",
    view: SurveyViewCreate,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/reports/views/:surveyViewUuid/form",
    view: SurveyViewUpdate,
    ...SUPERVISOR_AND_HIGHER,
  },
  {
    path: "/community",
    view: Community,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/community/search",
    view: CommunitySearch,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/community/topics/:topic",
    view: CommunityTopicSearch,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/discussions/:discussionId",
    view: SingleDiscussion,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/discussions/form",
    view: DiscussionForm,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/discussions/form/:discussionId",
    view: DiscussionForm,
    ...MEMBER_AND_HIGHER,
  },
  {
    path: "/reports/files/:uuid",
    view: PublicFile,
    ...DEFAULT_ACCESS,
  },
];
